import dayjs, { Dayjs } from 'dayjs';

export const getDisabledDate = (date: Dayjs) => date.isAfter() && !date.isSame(dayjs(), 'day');

export const getDisabledDateBefore = (date: Dayjs) =>
  date.isBefore() && !date.isSame(dayjs(), 'day');

export const getDisabledHours = () =>
  Array(24)
    .fill(null)
    .map((_, index) => index)
    .filter(h => h >= new Date().getHours() + 1);

export const getDisabledHoursBefore = () =>
  Array(24)
    .fill(null)
    .map((_, index) => index)
    .filter(h => h < new Date().getHours());

export const getDisabledMinutesBefore = () =>
  Array(60)
    .fill(null)
    .map((_, index) => index)
    .filter(h => h < new Date().getMinutes());

export const getDisableTime = (date: Dayjs, disableFutureMinutes = false) => {
  if (!date.isSame(dayjs(), 'day')) return {};

  const now = new Date();
  return {
    disabledHours: getDisabledHours,
    ...(disableFutureMinutes
      ? {
          disabledMinutes: (selectedHour: number) =>
            selectedHour === now.getHours()
              ? Array.from({ length: 60 }, (_, minute) => minute).filter(
                  minute => minute > now.getMinutes(),
                )
              : [],
        }
      : {}),
  };
};

export const getDisableTimeBefore = (value?: string | Dayjs) => {
  if (!value) return {};

  const date = dayjs(value);

  const isToday = date.isSame(dayjs(), 'day');

  return isToday
    ? {
        disabledHours: getDisabledHoursBefore,
        disabledMinutes: date.isSame(dayjs(), 'hour') ? getDisabledMinutesBefore : () => [],
      }
    : {};
};

export const getDisableTimeStartEnd =
  (startValue?: string | Dayjs | null, isEnd?: boolean) => (selectedTime: Dayjs | null) => {
    if (!selectedTime) return {};

    const now = dayjs();
    const start = startValue ? dayjs(startValue) : null;

    // ---- START PICKER ----
    if (!isEnd) {
      const isToday = selectedTime.isSame(now, 'day');

      if (!isToday) return {};

      const isCurrentHour = selectedTime.hour() === now.hour();

      return {
        disabledHours: getDisabledHoursBefore,
        disabledMinutes: isCurrentHour ? getDisabledMinutesBefore : () => [],
      };
    }

    // ---- END PICKER ---- (with +1 minute rule)
    if (isEnd && start) {
      const isSameDay = selectedTime.isSame(start, 'day');

      const minAllowed = start.add(1, 'minute'); // <<< HERE: +1 MINUTE RULE

      return {
        disabledHours: () => {
          const arr: number[] = [];

          if (isSameDay) {
            // disable hours strictly less than minAllowed.hour()
            for (let h = 0; h < minAllowed.hour(); h++) arr.push(h);
          }

          return arr;
        },

        disabledMinutes: (hour: number) => {
          // Different day → all minutes allowed
          if (!isSameDay) return [];

          // If hour < minAllowed.hour → disable all minutes
          if (hour < minAllowed.hour()) {
            return Array.from({ length: 60 }, (_, i) => i);
          }

          // If hour > minAllowed.hour → allow all minutes
          if (hour > minAllowed.hour()) return [];

          // Same hour → disable minutes < minAllowed.minute()
          const arr: number[] = [];
          for (let m = 0; m < minAllowed.minute(); m++) arr.push(m);
          return arr;
        },
      };
    }

    return {};
  };

export const mergeDateAndTime = (datePart: Dayjs, timePart: Dayjs) => {
  return datePart
    .hour(timePart.hour())
    .minute(timePart.minute())
    .second(timePart.second())
    .millisecond(timePart.millisecond());
};
